module.exports = __webpack_public_path__ + "static/media/himatera_itdel_logo.20c117df.png";